// extracted by mini-css-extract-plugin
export default {"selfieImage":"PictureOrSelfie_selfieImage__oarir","selfieGreeting":"PictureOrSelfie_selfieGreeting__zrJVR"};